<template>
<div class="form-step-item">
    <div class="panel">
        <h3>Billing Information</h3>
        <div v-if="formData.patient_country === 'New Zealand'">
            <h5 class="label" v-if="formData.patient_type === 'nutrition'">Home PN Solution to be charged to *</h5>
            <h5 class="label" v-if="formData.patient_type === 'fluids'">IV Fluids, Consumables, Service and Delivery Fee should be charged to: *</h5>
            <div class="form-row">
                <div class="form-group col-5 billing-radio">
                    <div class="bax-boxed-radio">
                        <div class="bax-radio">
                            <input type="radio" id="charged_to_radio_health_benefits" class="css-checkbox" value="health benefits" v-model="formData.charged_to_radio" />
                            <label for="charged_to_radio_health_benefits" class="css-label">Health Benefits</label>
                        </div>
                        <div class="bax-radio">
                            <input type="radio" id="charged_to_radio_other" class="css-checkbox" value="other" v-model="formData.charged_to_radio" />
                            <label for="charged_to_radio_other" class="css-label">Other</label>
                        </div>
                    </div>
                    <span class="form-error" v-if="$v.formData.charged_to_radio.$dirty && !$v.formData.charged_to_radio.required">Required field</span>
                </div>
                <div class="form-group col-3 billing-other-label" v-if="formData.charged_to_radio === 'other'">
                    <label for="charged_to_radio_other_specify">For other, please specify: *</label>
                </div>
                <div class="form-group col-4" v-if="formData.charged_to_radio === 'other'">
                    <input type="text" class="form-control" v-model="formData.charged_to_radio_other_specify">
                    <span class="form-error" v-if="$v.formData.charged_to_radio_other_specify.$dirty && !$v.formData.charged_to_radio_other_specify.required">Required field</span>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-8" v-if="formData.patient_country === 'Australia'">
                <label for="charged_to_input" v-if="formData.patient_type === 'nutrition'">Home PN Solution should be charged to (confirm paying hospital) *</label>
                <label for="charged_to_input" v-if="formData.patient_type === 'fluids'">IV Fluids, Consumables, Service and Delivery Fee should be charged to:<br>(confirm paying hospital) *</label>
                <input type="text" class="form-control" v-model="formData.charged_to_input">
                <span class="form-error" v-if="$v.formData.charged_to_input.$dirty && !$v.formData.charged_to_input.required">Required field</span>
            </div>
            <div class="form-group col-4" v-if="formData.patient_country === 'Australia' || (formData.patient_country === 'New Zealand' && formData.patient_type === 'fluids')">
                <label for="po_number" v-if="formData.patient_type === 'nutrition'">Home PN Solution PO number *</label>
                <label for="po_number" v-if="formData.patient_type === 'fluids'">PO number *</label>
                <input type="text" class="form-control" v-model="formData.po_number">
                <span class="form-error" v-if="$v.formData.po_number.$dirty && !$v.formData.po_number.required">Required field</span>
            </div>
        </div>
      <div class="form-row">
        <div class="form-group col-4">
          <label for="billing_contact">Billing contact *</label>
          <input type="text" class="form-control" v-model="formData.billing_contact">
          <span class="form-error" v-if="$v.formData.billing_contact.$dirty && !$v.formData.billing_contact.required">Required field</span>
        </div>
        <div class="form-group col-4">
          <label for="billing_phone">Phone number *</label>
          <input type="text" class="form-control" v-model="formData.billing_phone">
          <span class="form-error" v-if="$v.formData.billing_phone.$dirty && !$v.formData.billing_phone.required">Required field</span>
        </div>
        <div class="form-group col-4">
          <label for="billing_email">Email address *</label>
          <input type="text" class="form-control" v-model="formData.billing_email">
          <span class="form-error" v-if="$v.formData.billing_email.$dirty && !$v.formData.billing_email.required">Required field</span>
          <span class="form-error" v-if="$v.formData.billing_email.$dirty && !$v.formData.billing_email.email">Not a valid email</span>
        </div>
      </div>
        <div class="form-row" v-if="formData.patient_type === 'nutrition'">
            <div class="form-group col-8">
                <label for="consumables_charged_to">Consumables should be charged to (confirm paying hospital) *</label>
                <input type="text" class="form-control" v-model="formData.consumables_charged_to">
                <span class="form-error" v-if="$v.formData.consumables_charged_to.$dirty && !$v.formData.consumables_charged_to.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="consumables_po_number">Consumables PO number *</label>
                <input type="text" class="form-control" v-model="formData.consumables_po_number">
                <span class="form-error" v-if="$v.formData.consumables_po_number.$dirty && !$v.formData.consumables_po_number.required">Required field</span>
            </div>
        </div>
      <div class="form-row" v-if="formData.patient_type === 'nutrition'">
        <div class="form-group col-4">
          <label for="billing_contact">Billing contact *</label>
          <input type="text" class="form-control" v-model="formData.billing_contact2">
          <span class="form-error" v-if="$v.formData.billing_contact2.$dirty && !$v.formData.billing_contact2.required">Required field</span>
        </div>
        <div class="form-group col-4">
          <label for="billing_phone">Phone number *</label>
          <input type="text" class="form-control" v-model="formData.billing_phone2">
          <span class="form-error" v-if="$v.formData.billing_phone2.$dirty && !$v.formData.billing_phone2.required">Required field</span>
        </div>
        <div class="form-group col-4">
          <label for="billing_email">Email address *</label>
          <input type="text" class="form-control" v-model="formData.billing_email2">
          <span class="form-error" v-if="$v.formData.billing_email2.$dirty && !$v.formData.billing_email2.required">Required field</span>
          <span class="form-error" v-if="$v.formData.billing_email2.$dirty && !$v.formData.billing_email2.email">Not a valid email</span>
        </div>
      </div>
    </div>
</div>
</template>


<script>

import { required, requiredIf, email } from 'vuelidate/lib/validators';

export default {
    name: 'FormStep4',
    components: {
    },
    props: {
        formData: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    validations: {
        formData: {
            charged_to_input: {
                required: requiredIf(function () {
                    if (this.formData.patient_country === 'Australia') {
                        return true;
                    }
                    return false;
                }),
            },
            charged_to_radio: {
                required: requiredIf(function () {
                    if (this.formData.patient_country === 'New Zealand') {
                        return true;
                    }
                    return false;
                }),
            },
            charged_to_radio_other_specify: {
                required: requiredIf(function () {
                    if (this.formData.patient_country === 'New Zealand' && this.formData.charged_to_radio === 'other') {
                        return true;
                    }
                    return false;
                }),
            },
            po_number: {
                required: requiredIf(function () {
                    if (this.formData.patient_country === 'Australia' || (this.formData.patient_country === 'New Zealand' && this.formData.patient_type === 'fluids')) {
                        return true;
                    }
                    return false;
                }),
            },
            consumables_charged_to: {
                required: requiredIf(function () {
                    if (this.formData.patient_type === 'nutrition') {
                        return true;
                    }
                    return false;
                }),
            },
            consumables_po_number: {
                required: requiredIf(function () {
                    if (this.formData.patient_type === 'nutrition') {
                        return true;
                    }
                    return false;
                }),
            },
          billing_contact: {
            required,
          },
          billing_phone: {
            required,
          },
          billing_email: {
            required,
            email,
          },
          billing_contact2: {
            required: requiredIf(function () {
              if (this.formData.patient_type === 'nutrition') {
                return true;
              }
              return false;
            }),
          },
          billing_phone2: {
            required: requiredIf(function () {
              if (this.formData.patient_type === 'nutrition') {
                return true;
              }
              return false;
            }),
          },
          billing_email2: {
            required: requiredIf(function () {
              if (this.formData.patient_type === 'nutrition') {
                return true;
              }
              return false;
            }),
            email,
          },
        },
    },
    computed: {
    },
    methods: {
        validateForm() {
            this.$v.$touch();
            this.$emit('validation_response', !this.$v.$invalid);
        },
    },
};
</script>
